import ApiRequestManagerInstance from '../ApiRequestManager';

function lineupRequest() {
  const promise = new Promise<boolean>(async (resolve) => {
    try {
      await ApiRequestManagerInstance.post({
        endpoint: {
          url: 'apiUrl',
          section: 'user',
          subsection: 'reset',
          type: 'lineup',
        },
      });
      resolve(true);
    } catch (e) {
      console.error(e);
      resolve(false);
    }
  });

  return promise;
}

export default lineupRequest;
